// extracted by mini-css-extract-plugin
export var accordion = "accordionBlock-module--accordion--44e49";
export var accordionWrapper = "accordionBlock-module--accordionWrapper--8b4df";